import { render, staticRenderFns } from "./botao-novo.vue?vue&type=template&id=608983ca"
import script from "./botao-novo.vue?vue&type=script&lang=js"
export * from "./botao-novo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports